import { useEffect } from 'react';
import { prefetchProducts } from '@/store/products-preload';
import { useLangStore } from '@/store/lang-store';

// Fires the v1/products API call as soon as React hydrates,
// without waiting for forms-vendor / react-select to load.
// MainSearch consumes the same promise via prefetchProducts() — no duplicate request.
const ProductsPreloader = () => {
  const { langStore } = useLangStore();
  useEffect(() => {
    if (langStore) prefetchProducts(langStore);
  }, [langStore]);
  return null;
};

export default ProductsPreloader;
